export const languages = [
  { code: "en", label: "English" },
  { code: "hi", label: "हिन्दी" },
  { code: "bn", label: "বাংলা" },
  { code: "de", label: "Deutsch" },
  { code: "es", label: "Español" },
  { code: "ur", label: "اردو" },
  { code: "pa", label: "ਪੰਜਾਬੀ" },
  { code: "ne", label: "नेपाली" },
];

export const translations = {
  en: {
    nav: {
      solutions: "Solutions",
      companies: "Companies",
      about: "About",
      insights: "Insights",
      careers: "Careers",
      contact: "Contact",
    },
    common: {
      explore: "Explore",
      learnMore: "Learn more",
      getStarted: "Get started",
      viewAll: "View all",
      visitWebsite: "Visit website",
      back: "Back",
    },
  },
  hi: {
    nav: {
      solutions: "समाधान",
      companies: "कंपनियां",
      about: "हमारे बारे में",
      insights: "विचार",
      careers: "करियर",
      contact: "संपर्क",
    },
    common: {
      explore: "देखें",
      learnMore: "और जानें",
      getStarted: "शुरू करें",
      viewAll: "सभी देखें",
      visitWebsite: "वेबसाइट देखें",
      back: "वापस",
    },
  },
};

export const companies = [
  {
    slug: "qubosoft",
    name: "QuboSoft",
    shortName: "Soft",
    tagline: "Technology that moves business forward.",
    eyebrow: "Software, data & digital products",
    description:
      "QuboSoft helps teams turn complex ideas into useful, scalable digital products—from the first prototype to dependable daily operations.",
    color: "#2f80ed",
    softColor: "#eaf3ff",
    icon: "code",
    image: null,
    focus: "Digital products",
    capabilities: [
      "Web and mobile product development",
      "AI integrations and workflow automation",
      "Cloud, data, and platform engineering",
      "Product design, support, and optimisation",
    ],
    audience: "For founders, operators, and established teams that need technology to work harder.",
    approach: [
      "Clarify the opportunity and user need",
      "Design a focused product experience",
      "Build in small, testable increments",
      "Support the product as it grows",
    ],
    website: "https://qubosoft.com",
  },
  {
    slug: "quboinfra",
    name: "QuboInfra",
    shortName: "Infra",
    tagline: "Infrastructure with intent.",
    eyebrow: "Construction, materials & delivery",
    description:
      "QuboInfra brings disciplined planning and hands-on project delivery to the spaces, materials, and infrastructure that businesses depend on.",
    color: "#2b8a3e",
    softColor: "#eaf8ee",
    icon: "building",
    image: "/images/quboinfra-project.png",
    focus: "Built environments",
    capabilities: [
      "Commercial and industrial construction",
      "RCC products and material supply",
      "Project planning, coordination, and delivery",
      "Quality, safety, and site supervision",
    ],
    audience: "For organisations building durable workplaces, facilities, and operating capacity.",
    approach: [
      "Understand the site, scope, and constraints",
      "Plan the work, materials, and milestones",
      "Coordinate teams with clear accountability",
      "Deliver safely and review every detail",
    ],
    website: "https://quboinfra.com",
  },
  {
    slug: "qubokart",
    name: "QuboKart",
    shortName: "Kart",
    tagline: "Better products. Better everyday.",
    eyebrow: "Organic products & commerce",
    description:
      "QuboKart makes everyday commerce more dependable by connecting people with carefully sourced fresh and organic products.",
    color: "#e67700",
    softColor: "#fff4e5",
    icon: "cart",
    image: "/images/qubokart-fresh-produce.png",
    focus: "Everyday commerce",
    capabilities: [
      "Organic groceries and fresh produce",
      "Responsible sourcing and supplier relationships",
      "Simple ordering and fulfilment experiences",
      "Quality assurance from source to doorstep",
    ],
    audience: "For households and partners who value transparency, freshness, and convenience.",
    approach: [
      "Source from trusted, responsible partners",
      "Keep quality visible at every step",
      "Make the buying experience simple",
      "Learn from customers and improve continuously",
    ],
    website: "https://qubokart.com",
  },
];

export const solutions = [
  {
    slug: "technology",
    name: "Technology",
    eyebrow: "QuboSoft",
    icon: "code",
    color: "#2f80ed",
    description: "Digital products and platforms that are clear to use, ready to scale, and built around real business outcomes.",
    points: ["Web and mobile applications", "Cloud and data platforms", "Product design and engineering", "Support and optimisation"],
    link: "/companies/qubosoft",
  },
  {
    slug: "infrastructure",
    name: "Infrastructure",
    eyebrow: "QuboInfra",
    icon: "building",
    color: "#2b8a3e",
    description: "Practical construction and project delivery for the facilities, materials, and environments that keep businesses moving.",
    points: ["Commercial construction", "RCC products and materials", "Project management", "Quality and site supervision"],
    link: "/companies/quboinfra",
  },
  {
    slug: "commerce",
    name: "Commerce",
    eyebrow: "QuboKart",
    icon: "cart",
    color: "#e67700",
    description: "Thoughtful sourcing and easy commerce experiences that make quality products more accessible every day.",
    points: ["Organic and fresh products", "Sourcing and supply chain", "Ordering and fulfilment", "Customer experience"],
    link: "/companies/qubokart",
  },
  {
    slug: "ai",
    name: "AI solutions",
    eyebrow: "New ways to work",
    icon: "brain",
    color: "#7057d9",
    description: "Useful, responsible AI that helps teams find answers, automate repeatable work, and make better decisions.",
    points: ["Knowledge assistants", "Workflow automation", "Document intelligence", "Data-informed decisions"],
    link: "/solutions/ai",
  },
];

export const caseStudies = [
  {
    category: "AI & operations",
    title: "A clearer path from business question to useful AI",
    description: "A practical capability pattern for teams that want to make internal knowledge searchable, summarised, and easier to act on.",
    tags: ["AI readiness", "Knowledge systems"],
    icon: "brain",
    color: "#7057d9",
  },
  {
    category: "Digital products",
    title: "One connected view of a growing operation",
    description: "A product foundation that brings people, workflows, and business data into a calmer daily experience.",
    tags: ["Product engineering", "Cloud"],
    icon: "layers",
    color: "#2f80ed",
  },
  {
    category: "Infrastructure",
    title: "Planning spaces that are ready for real work",
    description: "A delivery model for commercial environments where schedule, materials, quality, and safety must stay aligned.",
    tags: ["Construction", "Project delivery"],
    icon: "building",
    color: "#2b8a3e",
  },
  {
    category: "Commerce",
    title: "Making everyday sourcing more trustworthy",
    description: "A commerce experience centred on clear product information, responsible sourcing, and dependable fulfilment.",
    tags: ["Organic products", "Customer experience"],
    icon: "cart",
    color: "#e67700",
  },
];

export const faqs = [
  {
    category: "Working with Qubo",
    questions: [
      {
        question: "Can I work with more than one Qubo company?",
        answer: "Yes. QuboGroup is designed to make cross-domain work easier. We can bring in QuboSoft, QuboInfra, QuboKart, or a focused combination when a project needs digital, physical, and commerce capabilities together.",
      },
      {
        question: "How do we begin a project?",
        answer: "Start with a short conversation about the outcome you want, the current challenge, and any important constraints. We will help define the right scope, team, and next step before work begins.",
      },
      {
        question: "Do you work with small businesses and new teams?",
        answer: "Yes. Engagements can start with a focused discovery or a small delivery milestone, then grow as the business gains confidence and clarity.",
      },
    ],
  },
  {
    category: "AI and technology",
    questions: [
      {
        question: "What kinds of AI solutions do you build?",
        answer: "We focus on useful business applications such as internal knowledge assistants, document and workflow automation, support copilots, and decision-support tools connected to the right data.",
      },
      {
        question: "How do you approach responsible AI?",
        answer: "We start with a clear use case, protect sensitive information, keep people in the loop for important decisions, and design for measurable value rather than adding AI for its own sake.",
      },
      {
        question: "Can you work with our existing tools and data?",
        answer: "Usually. The first step is understanding your current systems, data quality, access controls, and team workflow so the solution fits your environment instead of creating another isolated tool.",
      },
    ],
  },
  {
    category: "Delivery and support",
    questions: [
      {
        question: "How long does a typical engagement take?",
        answer: "It depends on the outcome and starting point. A discovery can be focused and short, while a full product, construction, or commerce initiative may run across several milestones. We will make the assumptions visible in the proposal.",
      },
      {
        question: "Do you provide support after launch or delivery?",
        answer: "Yes. Support can include product improvements, operational guidance, maintenance, quality reviews, and ongoing optimisation depending on the type of work.",
      },
    ],
  },
];

export const insights = [
  {
    slug: "a-practical-starting-point-for-ai",
    category: "AI & data",
    date: "August 2026",
    readTime: "5 min read",
    title: "A practical starting point for AI adoption",
    excerpt: "The best first AI project is usually close to a real workflow, easy to measure, and useful to the people doing the work every day.",
    icon: "brain",
    color: "#7057d9",
    sections: [
      {
        heading: "Start with friction, not fashion",
        paragraphs: [
          "AI becomes valuable when it removes a real bottleneck. Before choosing a model or tool, look for a recurring question, hand-off, or document-heavy task that slows a team down.",
          "A narrow workflow gives you a useful boundary. It also makes it easier to compare the time saved, the quality of the result, and the experience of the people using it.",
        ],
      },
      {
        heading: "Make trust part of the first version",
        paragraphs: [
          "Good AI experiences explain what they know, show where an answer came from, and give people a clear way to review or correct the result. Permission-aware access and careful data handling are part of the product, not a later add-on.",
        ],
      },
      {
        heading: "Build a learning loop",
        paragraphs: [
          "Treat the first release as a measured learning cycle. Capture the questions people ask, where the system needs help, and which outcomes matter most. That evidence tells you what to improve next.",
        ],
      },
    ],
  },
  {
    slug: "designing-connected-operations",
    category: "Ideas",
    date: "July 2026",
    readTime: "4 min read",
    title: "Designing connected operations across physical and digital work",
    excerpt: "When teams work across sites, systems, and suppliers, clarity becomes a competitive advantage.",
    icon: "layers",
    color: "#2f80ed",
    sections: [
      {
        heading: "The work is already connected",
        paragraphs: [
          "A customer request can affect a digital workflow, a physical site, a supplier, and a delivery promise. The experience feels fragmented when each part is planned in isolation.",
          "Mapping the hand-offs reveals where a shared view, a clearer decision, or a better status signal can reduce uncertainty.",
        ],
      },
      {
        heading: "Make the next action obvious",
        paragraphs: [
          "Useful systems do not just display information. They help people understand what changed, what needs attention, and who owns the next action.",
        ],
      },
    ],
  },
  {
    slug: "what-makes-commerce-trustworthy",
    category: "Commerce",
    date: "June 2026",
    readTime: "4 min read",
    title: "What makes an online marketplace trustworthy?",
    excerpt: "Reliable commerce is built from small signals: honest product information, visible sourcing, and consistent fulfilment.",
    icon: "cart",
    color: "#e67700",
    sections: [
      {
        heading: "Trust is designed into the details",
        paragraphs: [
          "Customers notice when product information is clear, delivery expectations are realistic, and a business makes it easy to ask for help. These details often matter more than a louder promotion.",
        ],
      },
      {
        heading: "Consistency compounds",
        paragraphs: [
          "Every reliable order, transparent update, and thoughtful response makes the next purchase easier. A commerce experience earns loyalty by doing the basics well, repeatedly.",
        ],
      },
    ],
  },
];

export const stats = [
  { value: "3", label: "specialist companies" },
  { value: "1", label: "shared group vision" },
  { value: "4", label: "solution pathways" },
  { value: "∞", label: "ways to move forward" },
];

export const values = [
  {
    icon: "shield",
    title: "Integrity",
    description: "Clear expectations, responsible decisions, and relationships built to last.",
    color: "#2f80ed",
  },
  {
    icon: "spark",
    title: "Useful innovation",
    description: "New ideas matter when they make work, life, or delivery meaningfully better.",
    color: "#7057d9",
  },
  {
    icon: "chart",
    title: "Excellence",
    description: "We care about the details that turn a promising idea into a dependable result.",
    color: "#2b8a3e",
  },
  {
    icon: "leaf",
    title: "Sustainable value",
    description: "We build for the long term, with people, communities, and the environment in mind.",
    color: "#e67700",
  },
];

export const legalPages = {
  "/privacy-policy": {
    title: "Privacy Policy",
    description: "How QuboGroup handles personal information across its websites and services.",
    updated: "January 29, 2026",
    sections: [
      ["Information we collect", "We may collect information you provide when you contact us, request a service, subscribe to updates, or interact with our websites. This may include your name, contact details, organisation, and the information included in your message."],
      ["How we use information", "We use information to respond to enquiries, provide and improve services, maintain website security, understand usage, and communicate updates where you have asked to receive them."],
      ["Sharing and retention", "We do not sell personal information. Information may be shared with trusted service providers when needed to operate our websites or deliver a requested service. We retain information only for as long as it is needed for the purpose collected or required by law."],
      ["Your choices", "You may ask us to access, correct, or delete personal information we hold about you, subject to applicable legal requirements. Contact privacy@qubogroup.com for privacy questions."],
    ],
  },
  "/terms-of-service": {
    title: "Terms of Service",
    description: "The terms that apply when you use QuboGroup websites, products, and services.",
    updated: "January 29, 2026",
    sections: [
      ["Using our services", "You agree to use QuboGroup websites and services lawfully, respectfully, and in a way that does not disrupt or compromise the experience of other users."],
      ["Our content and work", "Website content, design, software, and materials are owned by or licensed to QuboGroup unless stated otherwise. Project-specific ownership and usage rights are defined in the relevant agreement."],
      ["Third-party services", "Our websites may link to third-party services or company websites. Those services have their own terms and privacy practices, which you should review before using them."],
      ["Contact", "Questions about these terms can be sent to contact@qubogroup.com. These terms are governed by the laws of India and disputes are subject to the courts of Noida, Uttar Pradesh."],
    ],
  },
  "/cookie-policy": {
    title: "Cookie Policy",
    description: "How QuboGroup uses cookies and similar technologies.",
    updated: "January 29, 2026",
    sections: [
      ["What cookies are", "Cookies are small text files stored on your device by a website. They can help a website remember preferences, understand usage, and keep essential experiences working."],
      ["How we use them", "We may use essential cookies for core functionality and limited analytics cookies to understand how the website is used. We do not use cookies to sell personal information."],
      ["Your choices", "You can control or remove cookies through your browser settings. Disabling essential cookies may affect how parts of the website work."],
      ["Questions", "For questions about cookies or this policy, email privacy@qubogroup.com."],
    ],
  },
};
